const ru = {
  title: 'Каталог памятников',
  catalogButton: 'Посмотреть каталог',
};

export default {
  ru,
};
